module.exports = __webpack_public_path__ + "img/mobile_banner.f0fd7b4b.jpg";